export default {
  "nav.bank.payments": "Kohdistukset",
  "nav.bank.overview": "Kohdistusten yhteenveto",
  "nav.bulk_invoicing": "Massalaskutus",
  "nav.bank.enable_banking": "Pankkiyhteydet",
  "nav.me": "Oma työpöytä",
};
